import { css } from 'styled-components'

const ellip = (type: 'line1' | 'line2' | 'line3') => {
  if (type === 'line1') {
    return css`
      display: inline-block;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      word-break: break-all;
      text-align: left;
    `
  } else if (type === 'line2') {
    return css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
      text-align: left;
    `
  } else if (type === 'line3') {
    return css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      word-break: break-all;
      text-align: left;
    `
  }
}

const xScrollStyle = css`
  overflow-x: auto;
  white-space: nowrap;
  &::-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    display: none;
  }
`

const layoutMaxSize = css`
  max-width: 688px;
`
const mediaMaxWidth = (width: string) => {
  return `@media screen and (max-width: ${width}px)`
}

const ZIndex = {
  TopMenu: 4,
  TopButton: 3,
  CategoryChips: 5,
  BottomFixedContents: 2,
  BottomSheet: 100,
}

export { ellip, xScrollStyle, mediaMaxWidth, layoutMaxSize, ZIndex }
